import { useMutation } from "@apollo/client";
import {
  CancelContributionMutation,
  CancelContributionMutationVariables,
  TransactionTime,
} from "@ctypes";
import { CANCEL_CONTRIBUTION, TRANSACTIONS, USER } from "@graphql";
import { DEFAULT_SIZE } from "@hooks/transfers";

export const useCancelContribution = () => {
  return useMutation<CancelContributionMutation, CancelContributionMutationVariables>(
    CANCEL_CONTRIBUTION,
    {
      refetchQueries: [
        USER,
        {
          query: TRANSACTIONS,
          variables: {
            size: DEFAULT_SIZE,
            time: TransactionTime.Upcoming,
          },
        },
      ],
      awaitRefetchQueries: true,
    },
  );
};
